<ui-button
    text="Open dialog"
    (click)="showError()">
</ui-button>
